import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Layer, Line, LineState, Market } from '../shared.types';

@Component({
  selector: 'create-contract-layer',
  templateUrl: './create-contract-layer.component.html',
  styleUrls: ['./create-contract-layer.component.scss']
})
export class CreateContractLayerComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<CreateContractLayerComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) {
  }

  private *_getLines(programId: number): Iterable<Line> {
    yield new Line(10, '', 0, 'Reinsurer 1', LineState.draft);
    yield new Line(11, '', 1, 'Reinsurer 2', LineState.draft);
    yield new Line(12, '', 2, 'Reinsurer 3', LineState.draft);
  }

  private *_getMockLayers(): IterableIterator<Layer> {
    if (this.data.data.iteration === 1) {
      return yield new Layer(++this.data.data.iteration, `Layer ${this.data.data.iteration}`, 0, { amount: 100000000, excess: 40000000 }, { amount: 200000000, excess: 0 }, '1@100', false, Array.from(this._getLines(0)));
    }
    if (this.data.data.iteration === 2) {
      return yield new Layer(++this.data.data.iteration, `Layer ${this.data.data.iteration}`, 0, { amount: 140000000, excess: 140000000 }, { amount: 280000000, excess: 0 }, '1@100', false, Array.from(this._getLines(0)));
    }
    if (this.data.data.iteration === 3) {
      return yield new Layer(++this.data.data.iteration, `Layer ${this.data.data.iteration}`, 0, { amount: 200000000, excess: 280000000 }, { amount: 400000000, excess: 0 }, '1@100', false, Array.from(this._getLines(0)));
    }
  }

  private *_getMarkets(): Iterable<Market> {
    let seed = 0;
    yield new Market(++seed, `Reinsurer ${seed}`, true, true,  LineState.draft, new Date(), 'Jane Doe' );
    yield new Market(++seed, `Reinsurer ${seed}`, true, true,  LineState.draft, new Date(), 'Jane Doe' );
    yield new Market(++seed, `Reinsurer ${seed}`, true, false, LineState.draft, new Date(), 'Jane Doe' );
    yield new Market(++seed, `Reinsurer ${seed}`, false, true, null,            new Date(), 'Jane Doe' );
  }

  ok() {
    const layers  = Array.from(this._getMockLayers());
    this.dialogRef.close({ isOk: true, layers });
  }

  cancel() {
    this.dialogRef.close({ isCancel: true });
  }

  ngOnInit() { }

}
